import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux'

const EmptyNotice = (props) => {
    const { messages, isChannelTags} = props
    return (
            <Wrap>
                <Notice>{messages.info_list_no_result}</Notice>
                <Notice>- {messages.info_list_no_result_adjust_filter}</Notice>
                <Notice>- {messages.rank_no_result_03}</Notice>
                {isChannelTags && <Notice>- {messages.info_list_no_channel_id}</Notice>}
            </Wrap>
    )
}
const mapStateToProps = state => {
    return {
        messages: state.Messages,
    }
}
export default connect(mapStateToProps)(EmptyNotice);
const Wrap = styled.div`
    display: flex;
    flex-direction: column;
`
const Notice = styled.div`
    font-size: 14px;
    color: #787878;
    line-height: 1.5rem;
`



// WEBPACK FOOTER //
// ./src/InfoList/EmptyNotice.js